/**
 * @GENERATED from Figma node 3608:50996
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const CrunchbaseDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#0287D1"
      d="M20.001 2H4A2.01 2.01 0 0 0 2 3.999V20A2.01 2.01 0 0 0 3.999 22H20A2.01 2.01 0 0 0 22 20.001V4A2.01 2.01 0 0 0 20.001 2"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.326 14.757q-.396.342-.886.527a3.07 3.07 0 0 1-2.823-.318v.318h-1.26V6.476h1.25V9.9a3.1 3.1 0 0 1 1.501-.524h.224c2.845-.007 4.155 3.535 1.994 5.38m-.186-2.304a1.753 1.753 0 1 1-3.506 0c.05-2.286 3.454-2.286 3.506 0"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M7.873 14.054a1.757 1.757 0 0 0 2.327-.87h1.384c-.863 3.532-6.061 2.907-6.061-.729 0-3.64 5.198-4.264 6.06-.73H10.2a1.756 1.756 0 0 0-2.842-.514 1.757 1.757 0 0 0 .515 2.843"
    />
  </svg>
);
const ForwardRef = React.forwardRef(CrunchbaseDark);
export { ForwardRef as CrunchbaseDark };
